export default __webpack_public_path__ + "static/content-78e39919455f6f594978fd4ca73ba9d1.jpg";